export default "__VITE_ASSET__BJEK$Cqv__"